"use client";

import React, { useState } from "react";
import Button from "@/components/ui/buttons/Button";
import TestDriveModal from "./TestDriveModal";
import { Vehicle, VehicleStatusType } from "@alba-cars/common-modules";

interface TestDriveButtonProps {
  car: Vehicle;
  className?: string;
  disabled?: boolean;
}

const TestDriveButton = ({ car, className, disabled = false }: TestDriveButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isSold = car.status === VehicleStatusType.SOLD;
  const buttonDisabled = disabled || isSold;

  const buttonText = isSold ? "Vehicle Sold" : "Book a free test drive";

  return (
    <>
      <Button
        buttonText={buttonText}
        bgColor="primary"
        textColor="white"
        disabled={buttonDisabled}
        className={
          className
            ? className
            : "my-2 w-full py-4 text-center text-white transition-all duration-300 ease-in-out hover:bg-primary-dark disabled:cursor-not-allowed disabled:opacity-50"
        }
        onClick={() => setIsModalOpen(true)}
      />

      <TestDriveModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} vehicleId={car.id} />
    </>
  );
};

export default TestDriveButton;
